import { useEffect, useState } from "react";
import { TemplateDialog } from "./template-dialog";
import { PMButton } from "../../utils/PMButton";

export const TemplateDialogButton = (props) => {
  const { setFieldValue, values, fieldName, className, styleType } = props;

  const [dialogOpen, setDialogOpen] = useState(false);

  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedAction, setSelectedAction] = useState({ mode: "append" });

  useEffect(() => {
    if (selectedTemplate) {
      if (setFieldValue) {
        const currentValue = values?.[fieldName] || "";
        const nextValue =
          selectedAction.mode === "append" && currentValue
            ? `${currentValue}<p><br></p>${selectedTemplate.content}`
            : selectedTemplate.content;

        setFieldValue(fieldName, nextValue);
      }

      if (props.onChange) {
        props.onChange({
          target: {
            name: "template",
            value: selectedTemplate.id,
            data: selectedTemplate,
            action: selectedAction,
          },
        });
      }
    }

    // reset template after setFieldValue/ onChange and close dialog
    setSelectedTemplate(null);
    setDialogOpen(false);
  }, [selectedTemplate]);

  // reset template when dialog closes
  // useEffect(() => {
  //   if (!dialogOpen) {
  //     // wait for dialog to close before resetting
  //     setTimeout(() => {
  //       setSelectedTemplate(null);
  //     }, 500);
  //   }
  // }, [dialogOpen]);

  return (
    <>
      <PMButton
        className={className}
        styleType={styleType}
        onClick={() => setDialogOpen(true)}
      >
        Velg mal
      </PMButton>
      <TemplateDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        hasExistingContent={Boolean((values?.[fieldName] || "").trim())}
        onChange={(template, action) => {
          setSelectedAction(action || { mode: "append" });
          setSelectedTemplate(template);
        }}
      />
    </>
  );
};

TemplateDialogButton.defaultProps = {
  styleType: "minimal",
};
